import Identity from './identity';

/**
 * Clears all identity related session/local storage items.
 * Returns void when successful, throws an error otherwise.
 *
 **/
export function clearSession(): void {
  try {
    Identity.userSegments = null;
    Identity.userIdentity = {};
    Identity.userProfile = null;
  } catch (e) {
    throw new Error('Error clearing session.');
  }
}

export default clearSession;
